import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Head from 'next/head';
import TeamPageTitle from '../components/team/TeamPageTitle';
import YuraTeamMember from '../components/team/yura-team-member';
import ElnurTeamMember from '../components/team/elnur-team-member';
import ArtemTeamMember from '../components/team/artem-team-member';

const Team = () => {
  return (
    <div className="flex flex-col min-h-screen justify-between">
      <Head>
        <title>Team of UpScore.ai</title>
        <meta
          name="description"
          content="UpScore.ai was created by experienced developers with expertise in AI, in collaboration with IELTS experts"
        />
      </Head>

      <Header />
      <TeamPageTitle />
      <YuraTeamMember />
      <ElnurTeamMember />
      <ArtemTeamMember />
      <Footer />
    </div>
  );
};

export default Team;
